import {
  clearReturnUrl,
  getReturnUrl,
  isTemporaryAuthError,
} from '@src/features/auth';
import Login from '@src/pages/Auth/Login';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

type LoginSearch = {
  redirect?: string;
  loginAs?: string;
};

export const Route = createFileRoute('/auth/login')({
  beforeLoad: async ({ context, search }) => {
    const { auth } = context;
    const { loginAs, redirect: redirectUrl } = search as LoginSearch;
    if (loginAs) {
      return;
    }

    try {
      await auth.verifyToken();
    } catch (verificationError) {
      if (
        isTemporaryAuthError(verificationError) &&
        auth.credentials
      ) {
        // Keep the locally valid session and continue to the return URL.
      } else {
        try {
          await auth.refreshToken();
        } catch (refreshError) {
          if (isTemporaryAuthError(refreshError)) {
            throw refreshError;
          }
          return;
        }
      }
    }

    const returnUrl = getReturnUrl(
      redirectUrl,
      auth.credentials?.user?.id,
    );
    clearReturnUrl();
    throw redirect({ href: returnUrl, replace: true });
  },
  head: () => ({
    meta: [{ title: getLocalizedTitle('auth.login', 'Login') }],
  }),
  component: Login,
});
